import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			communityPlsrIgniteContentSectionHeaderBigCls: string;
			communityPlsrIgniteContentSectionHeaderCls: string;
			communityPlsrIgniteContentSectionSubheaderCls: string;
		}
	},

	slug: string
}

class Hero extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('Community Plsr Ignite Hero Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.communityPlsrIgniteContentSectionHeaderBigCls || '', 'community_plsr_ignite_hero', { animCls: 'animate__lightSpeedInLeft', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.communityPlsrIgniteContentSectionHeaderCls || '', 'community_plsr_ignite_hero', { animCls: 'animate__zoomIn50P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.communityPlsrIgniteContentSectionSubheaderCls || '', 'community_plsr_ignite_hero', { animCls: 'animate__fadeInRight25P', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Hero;